import { apiClient } from '@/api/client'
import type { AdminUser } from '@/features/admin/api/users.api'
import type { ApiSuccessResponse, PaginationMeta } from '@/types/api'

export interface OrgHire {
  candidateName: string
  jobTitle: string
  lmsSource: string | null
  academicPhase: string | null
  hiredAt: string
}

export interface AdminOrganization {
  id: number
  name: string
  status: string
  recruiterCount: number
  jobCount: number
  hiredCount: number
  createdAt: string
}

export const adminOrganizationsApi = {
  // Backend returns the paginator fields directly as `meta` (not meta.pagination).
  list: async (params: { q?: string; status?: string; per_page?: number; page?: number } = {}): Promise<{ organizations: AdminOrganization[]; pagination: PaginationMeta }> => {
    const { data } = await apiClient.get<ApiSuccessResponse<AdminOrganization[]> & { meta: PaginationMeta }>('/admin/organizations', { params })
    return { organizations: data.data, pagination: data.meta }
  },

  recruiters: async (orgId: number): Promise<AdminUser[]> => {
    const { data } = await apiClient.get<ApiSuccessResponse<AdminUser[]>>(`/admin/organizations/${orgId}/recruiters`)
    return data.data
  },

  hires: async (orgId: number): Promise<OrgHire[]> => {
    const { data } = await apiClient.get<ApiSuccessResponse<OrgHire[]>>(`/admin/organizations/${orgId}/hires`)
    return data.data
  },

  updateStatus: async (orgId: number, status: string): Promise<void> => {
    await apiClient.patch(`/admin/organizations/${orgId}/status`, { status })
  },
}
